module.exports = __webpack_public_path__ + "static/img/ic_arrow_left_black.19ccf329.svg";